"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemVideo = void 0;
var _react = _interopRequireDefault(require("react"));
var _videoBg = _interopRequireDefault(require("b2b-components/theme/assets/images/video-bg.png"));
var ItemVideo = function ItemVideo(_ref) {
  var itemIndex = _ref.itemIndex,
    iframeElement = _ref.iframeElement,
    isVimeo = _ref.isVimeo,
    url = _ref.url,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Gallery-ItemVideoWrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Gallery-ItemVideoIframe"
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    allow: "autoplay",
    allowFullScreen: isVimeo,
    frameBorder: "0"
    // @ts-ignore
    ,

    mozallowfullscreen: isVimeo,
    ref: iframeElement,
    src: url.href,
    title: "".concat(title, " - video ").concat(itemIndex || ''),
    webkitallowfullscreen: isVimeo
  })), /*#__PURE__*/_react["default"].createElement("img", {
    alt: title,
    className: "cds-Gallery-ItemVideoImg",
    src: _videoBg["default"],
    title: title
  }));
};
exports.ItemVideo = ItemVideo;